export default __webpack_public_path__ + "static/media/copy-custom.27b9e6f0.svg";